import { AnswerTypes } from 'Stories/components/Form/answerTypes';
import { HOSAssessmentQuestionType } from './HOSQuestionType';

export const questions = [
  {
    name: 'a945d8f7-ade3-428e-aa9d-b9f33e28d5fc',
    textId: 'screenings.form.adult-well-being.physical-health-days',
    questionType: HOSAssessmentQuestionType.NUMBERTEXT,
    answerType: AnswerTypes.TEXTBOX,
    options: [
      {
        name: 'afc3ab7a-568d-487e-944e-b65c7b25b782',
        textId: 'screenings.answer.well-being.number-of-days-zero-to-thirty',
      },
      {
        name: 'd5b55645-b6fc-4238-9ac8-ff2e908e2eee',
        textId: 'common.none',
      },
    ],
  },
  {
    name: '4b250edf-b739-4a55-80cb-ed1bbd0c6b3c',
    textId: 'screenings.form.adult-well-being.mental-health-days',
    questionType: HOSAssessmentQuestionType.NUMBERTEXT,
    answerType: AnswerTypes.TEXTBOX,
    options: [
      {
        name: 'f1e8654b-0a3b-4c03-be53-b549e50ef420',
        textId: 'screenings.answer.well-being.number-of-days-zero-to-thirty',
      },
      {
        name: '03c36ccb-2441-4f27-a8f7-1819e22006a1',
        textId: 'common.none',
      },
    ],
  },
  {
    name: '1c92f809-2f59-45cf-b8bc-0b977653780f',
    textId: 'screenings.form.adult-well-being.unsteady-walking',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: 'dd45067a-6527-4d57-89a9-477343da057e',
        textId: 'common.yes',
      },
      {
        name: '81d9fea5-ddbd-4d20-bef2-4012fb55600d',
        textId: 'common.no',
      },
      {
        name: '775cad95-747a-4a0d-9af7-b631c5dfed3e',
        textId: 'common.not-sure',
      },
    ],
  },
  {
    name: '63c084fd-4fae-466a-b8fa-97c3e256afe6',
    textId: 'screenings.form.adult-well-being.fall-risks',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    dependencies: ['dd45067a-6527-4d57-89a9-477343da057e'],
    options: [
      {
        name: '499c70ee-ef01-4710-93e8-8d36a2c7504d',
        textId: 'common.yes',
      },
      {
        name: '6f0d3a49-fef8-43c7-b8c2-7e64555afd4a',
        textId: 'common.no',
      },
      {
        name: 'f8a1176d-00de-4a50-9540-572e6f240973',
        textId: 'common.not-sure',
      },
    ],
  },
  {
    name: '31dc56cd-2c43-4554-9110-362485f94d0f',
    textId: 'screenings.form.adult-well-being.physical-activity',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: '9eae6544-eb6b-4a0d-a841-5350f001a1d2',
        textId: 'common.yes',
      },
      {
        name: 'ccaee8a0-a3fc-4a66-90da-f1ec526be8d7',
        textId: 'common.no',
      },
      {
        name: 'f6f7cecc-191c-4a83-b2e2-a61bb6740a47',
        textId: 'common.not-sure',
      },
    ],
  },
  {
    name: '29756bed-ac2c-444a-8829-8000871f6a79',
    textId: 'screenings.form.adult-well-being.bladder-control',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: '7d62f982-a32c-4ea7-ad12-12435f850d99',
        textId: 'common.yes',
      },
      {
        name: '4e7c7d80-3f21-4f8b-886b-496ae6b5c957',
        textId: 'common.no',
      },
      {
        name: 'bfee0277-81c5-43d4-b4d0-b6830eed7b0f',
        textId: 'common.not-sure',
      },
    ],
  },
  {
    name: 'ba6297bd-7214-48c9-ade0-bf773f5f8b9e',
    textId: 'screenings.form.adult-well-being.bladder-control-methods',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    dependencies: ['7d62f982-a32c-4ea7-ad12-12435f850d99'],
    options: [
      {
        name: 'a1c6cd2a-45ad-4e96-9eda-54887ae23d6c',
        textId: 'common.yes',
      },
      {
        name: 'b83a7a30-2138-4112-a263-61cfc0999a4c',
        textId: 'common.no',
      },
      {
        name: '1b9c0836-a35a-4247-8db0-d145ee663c3e',
        textId: 'common.not-sure',
      },
    ],
  },
  {
    name: '68688e64-ab35-4768-8957-87dca12d9ba3',
    textId: 'screenings.form.adult-well-being.afford-doctor',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: 'eca2edb3-c8a6-406b-9819-72fa57e8bcf0',
        textId: 'common.yes',
      },
      {
        name: 'bf107586-35d3-4eef-b3e6-577c9348147f',
        textId: 'common.no',
      },
      {
        name: 'b83b32a4-70f5-46a5-a12b-fc52c24d00b7',
        textId: 'common.not-sure',
      },
    ],
  },
  {
    name: '98a18e9d-ef66-402b-a245-3516bd402ed7',
    textId: 'screenings.form.adult-well-being.last-checkup',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: 'ebbc7f82-d990-4893-89de-44cfbeacf07b',
        textId: 'screenings.answer.well-being.within-the-past-year',
      },
      {
        name: '102dcb43-0222-48cd-8049-f25badda4745',
        textId: 'screenings.answer.well-being.within-the-past-two-years',
      },
      {
        name: 'fbd42548-a336-46b8-b6e3-679a3791dd37',
        textId: 'screenings.answer.well-being.within-the-past-five-years',
      },
      {
        name: 'd7cbbe30-55cf-4c15-ad63-1a7f31504a7f',
        textId: 'screenings.answer.well-being.five-or-more-years-ago',
      },
    ],
  },
  {
    name: '03c3c49c-fdd2-4902-9de4-39dfa27b52b2',
    textId: 'screenings.form.adult-well-being.help-reading-materials',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: 'd5247f3d-bfd1-4533-b22c-4daeecbbccc4',
        textId: 'common.never',
      },
      {
        name: '74ac9167-1097-46ba-8282-b9803c2a3a75',
        textId: 'common.rarely',
      },
      {
        name: '34a6dbe8-2a83-42db-9827-8fa8e6483f9f',
        textId: 'common.sometimes',
      },
      {
        name: 'dd0e6312-bdab-4faa-819e-2eea354166bb',
        textId: 'common.often',
      },
      {
        name: '8f43a3ee-37de-46bc-9b67-5dfa32781f65',
        textId: 'common.always',
      },
    ],
  },
  {
    name: '702046cc-c550-442a-9a0d-d9aa4e54302b',
    textId: 'screenings.form.adult-well-being.missed-medications',
    questionType: HOSAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: '49120f00-caef-4a7e-a0bf-2e60dbd7ccb6',
        textId: 'common.yes',
      },
      {
        name: '7cacf499-16ca-45da-915a-9757396f4143',
        textId: 'common.no',
      },
    ],
  },
];
